/**
 * @module SalesFlow/controller
 */

import { Constants } from 'core/constants';

import Injector from 'core/injector';

import {FlowController} from 'controller/flow-controller';

import DeviceList from 'view/element/bnt/device-list';
import Pricebox from 'view/element/shared/pricebox';

/**
 * @TODO Die Filter Logik ist gerade gekaputt.
 * Valentin klärt mit dem Channel wie wir weiter vorgehen.
 */
import Filters from 'view/element/shared/filter/filters';

import Subscription from 'model/type/subscription';
import AtomicDevice from 'model/type/atomic-device';
import SubscriptionGroupSwitcher from 'view/element/bnt/subscription-group-switcher';

import Offer from 'view/view/shared/offer/offer';
import DeviceOffer from 'view/view/shared/offer/device-offer';
import SimOnlyOffer from 'view/view/shared/offer/sim-only-offer';
import HardwareOffer from 'view/view/shared/offer/hardwareonly-offer';

import SubscriptionRepo from 'model/repo/subscription-repo';
import PurchasableDeviceRepo from 'model/repo/purchasable-device-repo';
import {SubscriptionList} from 'view/element/shared/subscription-list';
import {FlowCtas} from 'view/ctas/shared/flow-ctas';
import {AbstractSubscriptionGroupSwitcher} from 'view/element/shared/subscription-group-switcher';
import GeneralSalesObjectInterface from 'service/general-sales-object/general-sales-object-interface';

declare var $: JQueryStatic;

export class DeviceOverviewPageState {

    private _canBePurchased = false;

    constructor (subscriptionId: number, atomicDeviceId: number, hardwareOnly: boolean = false) {

        // Subscription and device
        if (undefined !== subscriptionId && undefined !== atomicDeviceId) {
            this._canBePurchased = true;
        }
        // simOnly
        else if (undefined !== subscriptionId) {
            this._canBePurchased = true;
        }
        // hardwareOnly
        else if (undefined !== atomicDeviceId && true === hardwareOnly) {
            this._canBePurchased = true;
        }

    }

    public canBePurchased (): boolean {
        return this._canBePurchased;
    }

}

/**
 * @internal
 * I come from previous step:
 *      => Tariff is locked
 */
export default abstract class DeviceOverviewController extends FlowController {

    protected _atomicDeviceId: number;
    protected _subscriptionId: number;

    protected _pageState: DeviceOverviewPageState;

    /** @TODO _activeOffer is unsued but would ne usable */
    protected _activeOffer: Offer;

    protected _pricebox: Pricebox;

    private _subscriptionGroupSwitcher: AbstractSubscriptionGroupSwitcher;

    /** @TODO Should not be any ;) */
    protected _subscriptionSelection: SubscriptionList<Offer[]>;

    protected _filters: Filters;

    /** @TODO Should not be any ;) */
    protected _deviceList: any;

    protected _deviceOffers: DeviceOffer[] = [];

    protected _subscriptionRepo: SubscriptionRepo;
    protected _purchasableDeviceRepo: PurchasableDeviceRepo;

    protected _subscription: Subscription;
    protected _focusSubscriptionId: number;

    protected _generalSalesObjectInterface: GeneralSalesObjectInterface;

    constructor (
        atomicDeviceId: number,
        subscriptionId: number,
        subscriptionRepo: SubscriptionRepo,
        purchasableDeviceRepo: PurchasableDeviceRepo,
        injector: Injector,
        focusSubscriptionId: number
    ) {

        super(injector);

        this._atomicDeviceId = atomicDeviceId;
        this._subscriptionId = subscriptionId;

        this._subscriptionRepo = subscriptionRepo;
        this._purchasableDeviceRepo = purchasableDeviceRepo;

        this.getInjector().getFlow().setAtomicDeviceId(this._atomicDeviceId, true);
        this.getInjector().getFlow().setSubscriptionId(this._subscriptionId, true);

        if (true === this.getInjector().getOptions().get('debug')) {
            const cnsl = console;
            cnsl.log('RealProductOverviewPage....');
        }

        this._subscriptionGroupSwitcher = this.createSubscriptionGroupSwitcher();

        this._pageState = new DeviceOverviewPageState(this._subscriptionId, this._atomicDeviceId);

        this._pricebox = new Pricebox(injector);

        this._focusSubscriptionId = focusSubscriptionId;

        this._subscriptionSelection = this.createSubscriptionList();
        this._filters = new Filters(injector);
        this._deviceList = new DeviceList(injector);

        this._generalSalesObjectInterface = this.getInjector().getGeneralSalesObjectInterface();

    }

    protected abstract createSubscriptionList (): SubscriptionList<DeviceOffer[]>;

    protected createCtas (): FlowCtas {
        return undefined;

    }

    protected createSubscriptionGroupSwitcher (): AbstractSubscriptionGroupSwitcher {
        return new SubscriptionGroupSwitcher(
            this.getInjector()
        );
    }

    /**
     * Setting tracking on page load. If a tariff and a device or tariff (VGOF-4712) has been selected, we send 'product detail' as pageType, else we send 'product listing' as pageType.
     */
    protected tracking () {
        if (false === this._pageState.canBePurchased()) {
            this.getInjector().getEvent().trigger('pageviewTracking@onload',
                {
                    subscription: this._subscription,
                    pageName: 'handys',
                    pageType: 'product listing',
                    deviceOffer: this.getActiveOffer()
                }
            );
        } else {
            this.getInjector().getEvent().trigger('pageviewTracking@onload',
                {
                    subscription: this._subscription,
                    pageName: 'handys',
                    pageType: 'product detail',
                    deviceOffer: this.getActiveOffer()
                }
            );
        }
    }

    protected render (): void {

        this._subscriptionSelection.update(this.getSubscriptions());
    }

    protected events (): void {

        this.getInjector().getEvent().listen('atomicDeviceId@changed', (eventObject: JQueryEventObject, data: any) => {

            const atomicDeviceId: number = data.atomicDeviceId;

            this._atomicDeviceId = atomicDeviceId;

            this._pageState = new DeviceOverviewPageState(this._subscriptionId, this._atomicDeviceId, this.getInjector().getFlow().getHardwareOnly());

            // A devive is selected, but not yet a subscription -> Scroll to scubsriptions
            if (undefined !== this._atomicDeviceId && undefined === this._subscriptionId) {

                $('html, body').animate({
                    scrollTop: $('#subscriptions').offset().top - 20
                }, 1000);
            }

            this._subscriptionSelection.update(this.getSubscriptions());

            // atomicDeviceId has changed and is now undefined or no subscription is selected
            // -> We can make no offer
            if (undefined === atomicDeviceId && (undefined === this._subscriptionId || Constants.Black_Id === this._subscriptionId)) {
                this._pricebox.hide();
                this.getInjector().getEvent().trigger('offer@none');

                return;
            }

            const offer: Offer = this.getActiveOffer();

            this.getInjector().getEvent().trigger('offer@changed', {
                offer: offer
            });

            if (true !== data.avoidTracking) {
                this.getInjector().getEvent().trigger('pageviewTracking@changed', {
                    pageName: 'handys',
                    pageType: 'product detail',
                    deviceOffer: offer
                });
            }

        });

        this.getInjector().getEvent().listen('subscriptionId@changed', (eventObject: JQueryEventObject, data: any) => {

            this._subscriptionId = data.subscriptionId;

            this._pageState = new DeviceOverviewPageState(this._subscriptionId, this._atomicDeviceId);

            this._subscription = this._subscriptionRepo.getSubscription(this.getSubscriptionId());
            const devices = this._purchasableDeviceRepo.getDevices(this._subscription);

            this._deviceOffers = devices.map(device => {

                /**
                 * Subscription is locked, so I use the first atomic device of the virtual device
                 */
                const offer = this._generalSalesObjectInterface.getSimHardwareOfferByAtomicDeviceIdAndSubscriptionId(
                    device.getAtomicDeviceByIndex(0).id,
                    this._subscription.id,
                    this._btx,
                    this.getInjector().getFlowState().getSalesChannel()
                 );

                return new DeviceOffer(device.getAtomicDeviceById(offer.deviceId), this._subscription, offer, this.getRedPlusFromFlow(), this.getInjector().getFlow().optionalServiceIds.elements);

            });

            this.getInjector().getFlow().setSubscriptionId(this.getSubscriptionId());

            this._deviceList.bind(this._deviceOffers);

            this._deviceList.update(this._deviceOffers);

            this._deviceList.filterList(this._filters.getActiveFilterOptionsByGroup());

            const selectedDeviceOffer = this.getActiveOffer();

            this.setSubscriptionName(this._subscription.name);

            // @TODO the next line where there, but noz commented. No idea why
            // this.getInjector().getFlow().setAtomicDeviceId(selectedDeviceOffer.atomicDeviceId);

            this.getInjector().getFlow().setSubscriptionId(selectedDeviceOffer.subscriptionId);

            this.getInjector().getEvent().trigger('offer@changed', {
                offer: selectedDeviceOffer
            });

            /**
             * If a tariff and device have been selected, send 'product detail' as pageType, if not then send 'product listing' as pageType
             */
            if (true !== data.avoidTracking) {

                if (undefined !== this._subscriptionId || (undefined !== this._atomicDeviceId && true === this.getInjector().getFlow().getHardwareOnly())) {
                    this.getInjector().getEvent().trigger('pageviewTracking@changed', {
                        pageName: 'handys',
                        pageType: 'product detail',
                        deviceOffer: selectedDeviceOffer,
                        overwriteRule: true
                    });
                } else {
                    this.getInjector().getEvent().trigger('pageviewTracking@changed', {
                        pageName: 'handys',
                        pageType: 'product listing',
                        deviceOffer: selectedDeviceOffer,
                        overwriteRule: true
                    });
                }
            }

        });

        this.getInjector().getEvent().listen('hardwareonly@selected', (eventObject: JQueryEventObject, data: any) => {

            this.getInjector().getFlow().setHardwareOnly(true);
            this.getInjector().getFlow().lockSubscription();

            /**
             * reset Red+ Data
             */
            this.getInjector().getFlow().resetRedPlusFlowData();

            this._subscriptionId = undefined;

            this._pageState = new DeviceOverviewPageState(this._subscriptionId, this._atomicDeviceId, true);

            $('#nsf-tariff-name').html('Smartphone ohne Tarif');

            const devices = this._purchasableDeviceRepo.getDevices();
            this._deviceOffers = devices.map(device => {

                /**
                 * Subscription is locked, so I use the first atomic device of the virtual device
                 */
                 const offer = this._generalSalesObjectInterface.getHardwareOnlyOfferByAtomicId(
                    device.getAtomicDeviceByIndex(0).id,
                    this.getInjector().getFlowState().getSalesChannel());

                return new HardwareOffer(device.getAtomicDeviceById(offer.deviceId), offer);

            });

            this._deviceList.update(this._deviceOffers);

            const selectedDeviceOffer = this.getActiveOffer();

            this.getInjector().getEvent().trigger('offer@changed', {
                offer: selectedDeviceOffer
            });

            if (true !== data.avoidTracking) {
                this.getInjector().getEvent().trigger('pageviewTracking@changed', {
                    pageName: 'handys',
                    pageType: 'product detail',
                    deviceOffer: selectedDeviceOffer
                });
            }

        });

        /**
         * When switching between subscriptionGroups no subscription should be selected,
         * even if a subsciption was selected in previous group
         * In this case we need to reset subscription and offer
         */
        this.getInjector().getEvent().listen('subscription@no-active', (eventObject: JQueryEventObject, groupName: string) => {

        });

        this.getInjector().getEvent().listen('subscriptionGroupName@changed', (eventObject: JQueryEventObject, groupName: string) => {

            this._subscriptionId = this.getInjector().getFlow().getSubscriptionId();

            if (undefined === this._subscriptionId) {

                this._pricebox.hide();
                this.getInjector().getEvent().trigger('offer@none');

            }

            this.getInjector().getRepos().setSubscriptionGroup(
                groupName
            );

            $.when(
                this.getInjector().getRepos().getPurchasableDeviceRepo(this.getInjector())
            ).done((
                purchasableDeviceRepo: PurchasableDeviceRepo
            ) => {

                this._purchasableDeviceRepo = purchasableDeviceRepo;

                this.getInjector().getEvent().trigger('tariffGroup@changed', groupName);

                if (false === this.getInjector().getFlow().getHardwareOnly() && undefined !== this._subscriptionId) {
                    this.getInjector().getEvent().trigger('subscriptionId@changed', {
                        subscriptionId: this._subscriptionId,
                        avoidTracking: true
                    });
                }

                this.getInjector().getEvent().trigger('pageviewTracking@changed', {
                    pageName: 'handys',
                    pageType: 'product listing',
                    deviceOffer: this.getActiveOffer(),
                    overwriteRule: true
                });

                const deviceOffers = this.getDeviceOffers();

                this._deviceList.bind(deviceOffers);

                this._deviceList.update(deviceOffers);

                this._deviceList.filterList(this._filters.getActiveFilterOptionsByGroup());

                // @TODO maybe resolve offer and fire offer@change if device and subscripton are not undefined
                if (undefined !== this._atomicDeviceId) {
                    this.getInjector().getEvent().trigger('atomicDeviceId@changed', {
                        atomicDeviceId: this._atomicDeviceId,
                        avoidTracking: true
                    });
                }

            });

        });

    }

    public setSubscriptionName (subscriptionName: string): void {
        $('#nsf-tariff-name').html(subscriptionName);
    }

    /**
     * Did the user opts in a RedPlus Option
     */
    protected getRedPlusFromFlow (): any[] {

        const offersRedPlus: any[] = [];
        const salesChannel = this.getInjector().getFlowState().getSalesChannel();
        const allRedPlusOptions = [
            ...this.getInjector().getFlow().redPlusAllnet.elements,
            ...this.getInjector().getFlow().redPlusData.elements,
            ...this.getInjector().getFlow().redPlusKids.elements,
            ...this.getInjector().getFlow().redPlusBasic.elements
        ];

        for (const offerId of allRedPlusOptions) {

            const redPlusOffer = this._generalSalesObjectInterface.getRedPlusOfferById(
                offerId,
                salesChannel);
            const redPlusSubscription = this._subscriptionRepo.getSubscription(redPlusOffer.subscriptionId);

            if ('HmK' === redPlusOffer.offerType) {
                const redPlusAtomicDevice = this._purchasableDeviceRepo.getAtomicDevice(redPlusOffer.deviceId, this._subscription);
                offersRedPlus.push(new DeviceOffer(redPlusAtomicDevice, redPlusSubscription, redPlusOffer));
            } else {
                offersRedPlus.push(new SimOnlyOffer(redPlusSubscription, redPlusOffer));
            }

        }

        return offersRedPlus;

    }

    protected getActiveSimOnlyOffer (): SimOnlyOffer {

        const subscription = this._subscriptionRepo.getSubscription(this._subscriptionId);
        const salesChannel = this.getInjector().getFlowState().getSalesChannel();

        return new SimOnlyOffer(
            subscription,
            this._generalSalesObjectInterface.getSimOnlyOfferBySubscriptionId(this._subscriptionId, this._btx, salesChannel),
            this.getRedPlusFromFlow(),
            this.getInjector().getFlow().optionalServiceIds.elements
        );

    }

    protected getActiveDeviceOffer (): DeviceOffer {

        let activeOffer: DeviceOffer = undefined;

        for (const deviceOffer of this._deviceOffers) {

            for (const atomicDevice of deviceOffer.atomicDevice.device.getAtomicDevices()) {

                if (this._atomicDeviceId === atomicDevice.id) {

                    activeOffer = deviceOffer;
                    if (activeOffer.isDevice()) {
                        activeOffer.setIsDeviceSelected(true);
                    }
                    break;
                }
                else {
                    deviceOffer.setIsDeviceSelected(false);
                }
            }

        }

        return activeOffer;

    }

    protected getActiveOffer (): Offer {

        if (false === this._pageState.canBePurchased()) {

            return undefined;

        }

        if (undefined === this._atomicDeviceId && undefined !== this._subscriptionId) {

            return this.getActiveSimOnlyOffer();

        }

        // if an atomicDeviceId is set in flow: Try to find that, select it and overwrite default
        return this.getActiveDeviceOffer();

    }

    protected getSubscriptionId (): number {

        return this._subscriptionId;

    }

    protected getSubscriptionsSimOnlyOffers (): SimOnlyOffer[] {

        const simOnlyOffers: SimOnlyOffer[] = [];
        const salesChannel = this.getInjector().getFlowState().getSalesChannel();

        for (const subscriptionId of this._subscriptionSelection.getSubscriptionIds()) {

            const subscription = this._subscriptionRepo.getSubscription(subscriptionId);

            let offer = this._generalSalesObjectInterface.getSimOnlyOfferBySubscriptionId(this._subscriptionId, this._btx, salesChannel);

            if (undefined === offer) {
                offer = this._generalSalesObjectInterface.getFirstAvailableOfferBySubscriptionId(
                    subscriptionId,
                    this._btx,
                    this.getInjector().getFlow().getSalesChannel()
                );
            }

            simOnlyOffers.push(new SimOnlyOffer(subscription, offer));

        }

        return simOnlyOffers;
    }

    protected getSubscriptionsOffers (): DeviceOffer[] {

        const offers: DeviceOffer[] = [];

        const subscriptionIds = this._subscriptionSelection.getSubscriptionIds();

        for (const subscriptionId of subscriptionIds) {

            const subscription = this._subscriptionRepo.getSubscription(subscriptionId);
            const atomicDevice = this._purchasableDeviceRepo.getAtomicDevice(this._atomicDeviceId, subscription);

            if (undefined === atomicDevice) {
                $('.tariff-module-tile[data-subscription-id="' + subscription.id + '"][data-tariff-group="' + this.getInjector().getFlow().getSubscriptionGroup() + '"]').hide().addClass('hide');
                continue;
            } else {
                $('.tariff-module-tile[data-subscription-id="' + subscription.id + '"][data-tariff-group="' + this.getInjector().getFlow().getSubscriptionGroup() + '"]').show().removeClass('hide');
            }

            const offer = this._generalSalesObjectInterface.getSimHardwareOfferByAtomicDeviceIdAndSubscriptionId(
                atomicDevice.id,
                subscription.id,
                this._btx,
                this.getInjector().getFlowState().getSalesChannel()
             );

            /** not every device is offered for each tariff */
            if (undefined !== offer) {
                // @TODO Fetch redplus from activeOffer, too
                offers.push(
                    new DeviceOffer(
                        atomicDevice,
                        subscription,
                        offer
                    )
                );
            }

        }

        return offers;
    }

    protected getSubscriptions (): Offer[] {

        if (undefined === this._atomicDeviceId) {
            return this.getSubscriptionsSimOnlyOffers();
        }

        return this.getSubscriptionsOffers();
    }

    protected getDeviceOffersWithoutActiveSubscription (): DeviceOffer[] {

        /** as we don't have a subscription at this point, I presume
         *  we're looking for hardware only purchasable devices
         */
        const devices = this._purchasableDeviceRepo.getDevices();

        const subscriptionGroupIds = this._subscriptionRepo.getSubscriptionGroupIds(
            this.getInjector().getFlow().getSubscriptionGroup()
        );

        const subscriptions = this._subscriptionRepo.getSubscriptions(subscriptionGroupIds, Constants.Subscription_Ids_To_Ignore);

        return devices.map(device => {

            const atomicDevice: AtomicDevice = device.getAtomicDeviceByIndex(0);

            /**
             * No tariff is locked, so I look for the tariff where the device
             * has the lowest onetime price
             */
            const offer = this._generalSalesObjectInterface.getLowestDevicePriceOfferForAtomicId (
                atomicDevice.id,
                subscriptions,
                this._btx,
                this.getInjector().getFlowState().getSalesChannel());

            if (undefined === offer) {
                return;
            }
            const subscription = this._subscriptionRepo.getSubscription(offer.subscriptionId);

            return new DeviceOffer(atomicDevice, subscription, offer, this.getRedPlusFromFlow(), this.getInjector().getFlow().optionalServiceIds.elements);

        });

    }

    protected getDeviceOffersWithActiveSubscription (): DeviceOffer[] {
        this._subscription = this._subscriptionRepo.getSubscription(this.getSubscriptionId());

        const devices = this._purchasableDeviceRepo.getDevices(this._subscription);

        const deviceOffers = devices.map(device => {

            /**
             * Subscription is locked, so I use the first atomic device of the virtual device
             */
            const offer = this._generalSalesObjectInterface.getSimHardwareOfferByAtomicDeviceIdAndSubscriptionId(
                device.getAtomicDeviceByIndex(0).id,
                this._subscription.id,
                this._btx,
                this.getInjector().getFlowState().getSalesChannel()
             );

            return new DeviceOffer(
                device.getAtomicDeviceById(offer.deviceId),
                this._subscription, offer,
                this.getRedPlusFromFlow(),
                this.getInjector().getFlow().optionalServiceIds.elements
            );

        });

        return deviceOffers;
    }

    protected getDeviceOffers (): DeviceOffer[] {

        this.getInjector().getRepos().setSubscriptionGroup(
            this.getInjector().getFlow().getSubscriptionGroup()
        );

        if (undefined === this._subscriptionId) {
            return this.getDeviceOffersWithoutActiveSubscription();
        }

        return this.getDeviceOffersWithActiveSubscription();
    }

    /**
     * @TODO This should be reviewed
     */
    private resetDedicatedFlowData () {

        let resetData = true;

        // if coming from subscribtion, don't reset
        if ('subscription_overview' === this._stepper.previousStep) {
            resetData = false;
        }

        // reloaded page
        if ('device_overview' !== this._stepper.previousStep) {
            resetData = false;
        }

        /**
         * Remove dedicated Flowdata (Accessories, Optional Services, HandyInsurance, noRedplus)
         */
        if (true === resetData) {
            this.getInjector().getFlow().resetDedicatedFlowData(true);
        }

    }

    public bind (): void {

        this._stepper.bind();
        this._subscriptionGroupSwitcher.bind();

        this.resetDedicatedFlowData();

        /**
         * hide Headline above Tariffs
         */
        if ('subscription_overview' === this._stepper.previousStep || this.getInjector().getFlow().isSubscriptionFirstFlow()) {
            $('#subscriptions').hide();
        }

        this._deviceOffers = this.getDeviceOffers();

        const offer = this.getActiveOffer();
        if (undefined !== offer) {
            this.setSubscriptionName(offer.subscriptionName);
        }

        this._deviceList.bind(this._deviceOffers);

        this._subscriptionSelection.bind(
            this.getSubscriptions()
        );

        this._subscriptionSelection.setActiveSubscriptionId(this._subscriptionId);
        this._filters.bind(this._deviceOffers);

        this._pricebox.bind(offer);

        if (undefined !== this._ctas) {
            this._ctas.bind(offer);
        }

        this.getInjector().getLoadingIndicator().hide();

        this.events();
        this.render();

        if (undefined !== offer && (offer.isDevice() || offer.isHardwareOnly())) {
            const url = offer.atomicDevice.getDevice().getDetailLink(this.getInjector().getOptions().get('device_detail_prefix'));
            this.getInjector().getEvent().trigger('stepper@device_detail_url', url);
        }

        this.tracking();
    }
}
